import { Unstable_Grid2 as Grid } from '@mui/material';

import { InfoField } from '@occc-app/design-system';

type LocationScanDataMSADetailsProps = {
  rjrAccountNumber: string | null;
};

export const LocationScanDataMSADetails = (props: LocationScanDataMSADetailsProps) => {
  const { rjrAccountNumber } = props;

  return (
    <Grid container spacing={2}>
      <Grid xs={3}>
        <InfoField label='RJR Account Number' value={rjrAccountNumber} />
      </Grid>
    </Grid>
  );
};
